// extracted by mini-css-extract-plugin
module.exports = {"root":"TenantAutoInfoActions_root__36_mh"};